import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../App/store";
import "./AudioTrack.scss";

export const AudioTrack = () => {
  const gameSelector = useSelector((state: RootState) => state.game);
  const [isMuted, setIsMuted] = useState<boolean>(true);
  const audioRef = useRef<HTMLAudioElement>(null);
  let audioUrl =
    "https://storage.googleapis.com/download/storage/v1/b/hq-slime-shadies-f1a50/o/642d45eac4d3d5002c28f542?alt=media&timestamp=1680688619608";

  const handleToggleMute = (mute: boolean) => {
    if (!audioRef.current) return;

    if (audioRef.current.paused) audioRef.current.play();

    audioRef.current.muted = mute;
    setIsMuted(mute);
  };

  useEffect(() => {
    if (!gameSelector.userInteract) return;
    handleToggleMute(gameSelector.status != "pending");
  }, [gameSelector.status, gameSelector.userInteract]);

  return (
    <div className="AudioTrack">
      {gameSelector.status == "pending" ? (
        <div onClick={() => handleToggleMute(!isMuted)}>
          <audio ref={audioRef} src={audioUrl} loop />
          <span className="material-symbols-outlined">
            {isMuted ? "volume_off" : "volume_up"}
          </span>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};
